<div class="mobile-navbar__menubar">
  <div class="mobile-navbar__menubar-icons-container">
    <!-- Sliding background indicator -->
    <div class="mobile-navbar__sliding-indicator" [style.left]="getActiveButtonPosition() + '%'"></div>

    @for (item of visibleMenuNavItems(); track item.display; let i = $index) {
      <button
        type="button"
        class="mobile-navbar__icon-button"
        (click)="$any(item)?.url ? itemClickHandler(item) : groupClickHandler(item)"
      >
        <mat-icon
          class="mobile-navbar__menubar-icon"
          [class.mobile-navbar__menubar-icon--active]="item | isRouteActive: routerUrl"
          [svgIcon]="item.icon"
        />
      </button>
    }
  </div>
</div>

<div class="mobile-navbar__routes-container" [class.mobile-navbar__routes-container--open]="isMenuOpen()">
  <div class="mobile-navbar__routes-container__overlay" (click)="groupClickHandler()"></div>
  <button class="mobile-navbar__routes-container__close-button" type="button" (click)="groupClickHandler()">
    <mat-icon [svgIcon]="'x-brown'" />
  </button>
  <div class="mobile-navbar__routes-container__routes" [class.routes-changing]="isRoutesChanging()">
    @if (currentGroupRoutes$ | async; as routes) {
      <route-item-group
        [isMobile]="true"
        [menuItems]="routes"
        [routerUrl]="routerUrl"
        (menuItemClick)="groupClickHandler()"
        (metaItemClick)="metaItemClickHandler($event)"
      />
    }
  </div>
</div>
